var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import classNames from "classnames";
import styles from "./theme.module.scss";
var ThemeColorMap;
(function (ThemeColorMap) {
    ThemeColorMap["primary"] = "p";
    ThemeColorMap["primary-text"] = "pt";
    ThemeColorMap["secondary"] = "s";
    ThemeColorMap["secondary-text"] = "st";
    ThemeColorMap["tertiary"] = "t";
    ThemeColorMap["text"] = "te";
    ThemeColorMap["text-light"] = "tl";
    ThemeColorMap["text-dark"] = "td";
    ThemeColorMap["background"] = "ba";
    ThemeColorMap["foreground"] = "fo";
    ThemeColorMap["grey"] = "g";
    ThemeColorMap["dark-grey"] = "dg";
    ThemeColorMap["white"] = "w";
    ThemeColorMap["black"] = "b";
    ThemeColorMap["green"] = "gr";
    ThemeColorMap["red"] = "r";
    ThemeColorMap["yellow"] = "y";
    ThemeColorMap["purple"] = "pu";
    ThemeColorMap["blue"] = "bl";
    ThemeColorMap["alert"] = "al";
    ThemeColorMap["slate"] = "sl";
    ThemeColorMap["ppn"] = "ppn";
})(ThemeColorMap || (ThemeColorMap = {}));
export function computeThemeClassNames(_a) {
    var _b;
    if (_a === void 0) { _a = {}; }
    var defaults = _a.defaults, light = _a.light, dark = _a.dark, params = __rest(_a, ["defaults", "light", "dark"]);
    var _c = defaults || params, background = _c.background, text = _c.text, border = _c.border, p = _c.pseudoBackground, mode = _c.mode, h = _c.hover, v = _c.variant;
    var _d = __read(colors(background, text, border), 3), b = _d[0], t = _d[1], bd = _d[2];
    var _e = __read(colors(dark === null || dark === void 0 ? void 0 : dark.background, dark === null || dark === void 0 ? void 0 : dark.text, dark === null || dark === void 0 ? void 0 : dark.border), 3), db = _e[0], dt = _e[1], dbd = _e[2];
    var className = classNames(styles["r"], (_b = {},
        _b[styles["b"]] = !!(b || db),
        _b[styles["c"]] = !!(t || dt),
        _b[styles["l"]] = !!light,
        _b[styles["d"]] = !!dark,
        _b[styles["p"]] = !!p,
        _b[styles["v"]] = !!v,
        _b[styles["h"]] = !!h,
        _b[styles["lm"]] = mode === "light",
        _b[styles["dm"]] = mode === "dark",
        // Default
        _b[styles["b-".concat(b)]] = !!b,
        _b[styles["t-".concat(t)]] = !!t,
        _b[styles["bd-".concat(bd)]] = !!bd,
        // Dark
        _b[styles["d-b-".concat(db)]] = !!db,
        _b[styles["d-t-".concat(dt)]] = !!dt,
        _b));
    return className;
}
function colors() {
    var colors = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        colors[_i] = arguments[_i];
    }
    return colors.map(color);
}
function color(color) {
    return color ? ThemeColorMap[color] : null;
}
